import React from 'react';
import {CircularProgress, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {Colors} from '@constants/colors.constants';
import SmallStatisticsCard from '@components/statistics/cards/SmallStatistics.card';
import {statisticsQuery} from '@store/statistics';
import {useObservable} from '@ngneat/react-rxjs';

const MarginPerLineCard = () => {
  const {t} = useTranslation();

  const [{marginByLine, loading}] = useObservable(statisticsQuery.marginByLine$);

  return (
    <Stack flex={1} height="360px" bgcolor={Colors.white} borderRadius="4px" p="20px">

      <Typography fontSize={18} fontWeight="700" mb="20px">
        {t('dashboard.statistics.finance.marginPerLine.title')}
      </Typography>
      {loading && <CircularProgress size={30}/>}
      {!loading && <Stack flex={1} width="100%" spacing={2}>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.marginPerLine.negativeLines')}
                  value={marginByLine?.executionLinesNegative != null ? marginByLine.executionLinesNegative : 105}
              />
          </Stack>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.marginPerLine.positiveLines')}
                  value={marginByLine?.executionLinesPositive != null ? marginByLine.executionLinesPositive : 750}
              />
          </Stack>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.marginPerLine.totalLines')}
                  value={marginByLine?.executionLinesTotal != null ? marginByLine.executionLinesTotal : 855}
              />
          </Stack>
      </Stack>}
    </Stack>
  );
};

export default MarginPerLineCard;
